import { IconPropsType } from '..';

export const TikTokIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21 41C32.0457 41 41 32.0457 41 21C41 9.9543 32.0457 1 21 1C9.9543 1 1 9.9543 1 21C1 32.0457 9.9543 41 21 41Z"
      fill="black"
      stroke="black"
      strokeWidth="0.131277"
      strokeMiterlimit="10"
    />
    <path
      d="M18.6026 29.2055C20.6509 29.2055 22.3113 27.545 22.3113 25.4967C22.3113 25.4363 22.3051 25.3774 22.3024 25.3175L22.3113 25.3252V9.9822H25.0832C24.9847 9.67205 24.897 9.34531 24.8218 9H21.3289V24.343L21.32 24.3353C21.3227 24.3952 21.3289 24.4541 21.3289 24.5145C21.3289 26.5628 19.6684 28.2233 17.6201 28.2233C16.8471 28.2233 16.1295 27.9864 15.5352 27.5817C16.2027 28.5617 17.3273 29.2055 18.6023 29.2055H18.6026Z"
      fill="#00F4F8"
    />
    <path
      d="M24.8203 15.8079V25.5623L24.7547 25.4371C24.3007 28.9775 21.2828 31.716 17.6186 31.716C15.8802 31.716 14.2856 31.0998 13.041 30.0741C14.3618 31.6766 16.3619 32.6982 18.6008 32.6982C22.2648 32.6982 25.2829 29.9597 25.7369 26.4193L25.8025 26.5445V16.9005C25.4574 16.5953 25.1307 16.2346 24.8203 15.8079Z"
      fill="#FF2357"
    />
    <path
      d="M30.2004 15.3293C29.0323 14.959 28.0446 14.3164 27.278 13.3407C26.3075 12.5815 25.5602 11.4852 25.0827 9.98242H22.3108V25.3254L22.3019 25.3177C22.3046 25.3776 22.3108 25.4365 22.3108 25.4969C22.3108 27.5453 20.6504 29.2057 18.6021 29.2057C17.327 29.2057 16.2025 28.5619 15.5349 27.5819C14.5549 26.9143 13.9111 25.7898 13.9111 24.5147C13.9111 22.4664 15.5715 20.806 17.6199 20.806C17.9238 20.806 18.2174 20.8466 18.5001 20.9154L18.5295 18.2963C14.5859 18.3351 11.4004 21.5439 11.4004 25.4969C11.4004 27.2354 12.0165 28.8299 13.0423 30.0745C14.2866 31.1003 15.8812 31.7164 17.6199 31.7164C21.2838 31.7164 24.302 28.978 24.7559 25.4375L24.8215 25.5628V15.8083C25.1319 16.2351 25.4587 16.5957 25.8037 16.9009V16.7905C25.882 16.898 25.9612 17.0004 26.0414 17.0997C27.1998 18.019 28.5605 18.3663 30.2004 18.501V15.3298V15.3293Z"
      fill="white"
    />
  </svg>
);
